import { ErrorPageStatusEnum } from '@lib/components/ErrorPage/enums';
import { APP_URLS } from 'constants/urls';
import { logger } from '@lib/services/logger';
import { HandleQrCodeSuccessProps } from './types';

export default function handleIdMode(
  data: string,
  {
    id,
    assetCode,
    assetQrPrefix,
    siteAreaCode,
    setCode,
    navigate,
    setErrorStatus,
  }: HandleQrCodeSuccessProps,
) {
  try {
    if (id !== undefined) {
      let isAvailable = false;
      if (assetCode) {
        isAvailable = data.indexOf(assetCode) > -1;
      }
      if (assetQrPrefix) {
        isAvailable = data.indexOf(assetQrPrefix) > -1;
      }
      if (siteAreaCode && !isAvailable) {
        isAvailable = data.indexOf(siteAreaCode) > -1;
      }

      logger.debug('Scanner: ID mode - code validation', {
        id,
        data,
        assetCode,
        assetQrPrefix,
        siteAreaCode,
        isAvailable,
      });

      if (isAvailable) {
        logger.info('Scanner: ID mode - code matched, navigating', { id });
        setCode(data);
        navigate(
          APP_URLS.app.tasks.completionCreate.getDynamicPath({
            pathParts: { id },
          }),
        );
      } else {
        logger.warn('Scanner: ID mode - code does not match task');
        setErrorStatus(ErrorPageStatusEnum.QrCodeScanFailed);
      }
    }
  } catch (error) {
    logger.error('Scanner: ID mode - unexpected error', {
      error: error instanceof Error ? error.message : String(error),
    });
  }
}
